// Constants
import { CORE_COLOR_MAP } from 'NewAngular/constants/core.constants';
export const HIGHCHARTS_BAR_CHART_DEFAULT_OPTIONS = {
    chart: {
        type: 'bar',
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
    },
    colors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n) => CORE_COLOR_MAP[n].code),
    title: false,
    xAxis: {
        gridLineWidth: 0,
        lineWidth: 0,
        labels: {
            enabled: false,
        },
        tickLength: 0,
    },
    yAxis: {
        title: false,
        labels: {
            overflow: 'justify',
            format: '{text}%',
        },
        gridLineWidth: 1,
        showFirstLabel: false,
        showLastLabel: false,
    },
    plotOptions: {
        series: {
            states: {
                inactive: {
                    opacity: 1,
                },
            },
        },
        bar: {
            groupPadding: 0,
            borderRadius: 0,
            borderWidth: 0,
            pointPadding: 0,
            dataLabels: {
                enabled: false,
            },
        },
    },
    legend: false,
    tooltip: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
};
export const NO_DATA_CLASS = 'panel-data-empty-message';
export const NO_DATA_DEFAULT_MESSAGE = 'No Data Available';
